import { createFileRoute } from '@tanstack/react-router';

// relative imports
import Loader from '../../../../../../../../../components/shared/custom-components/Loader';
import ExchangeSummary from '../../../../../../../../../components/source-management/exchanges/exchange-page/ExchangeSummary';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/summary',
)({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: ExchangeSummary,
  staticData: {
    isClientRoute: true,
  },
});
